import { NgModule } from '@angular/core';
import { SimIconComponent } from './sim-icon.component';

@NgModule({
  exports: [SimIconComponent],
  imports: [SimIconComponent]
})
export class SimIconModule {}
